export type PrintOptions = {
  preview?: boolean; // Whether to preview before printing
  width?: string;    // Width of the document (e.g., "80mm")
  margin?: string;   // Margin of the document (e.g., "0 0 0 0")
  copies?: number;   // Number of copies to print
  printerName?: string; // Name of the printer
  silent?: boolean;  // Whether to print silently without a prompt
  address?: string
};

export type PrintProfile = {
  name: string
  image: string
  username: string
}

export interface HIDDeviceInfo {
  productId: number;
  vendorId: number;
  productName?: string;
  manufacturerName?: string;
}

export type OrderItem = {
  item: string,
  quantity: string,
  price: string,
  total: string
  tax: string
}


export type RoomConfig = {
  owner: string
  staff: any[]
  products: any[]
  prepUnits: any[]
}

export interface FeelNativePlugin {
  print({ options, profile, data, address, printerName }: { options: PrintOptions, profile: PrintProfile, data: string, printerName: string, address: string }): Promise<void>;
  getAllPrinters(): Promise<any>,
  initializeScanner(): Promise<HIDDeviceInfo[]>,
  requestNewDevice(vendorId: number): Promise<any>,
  connectToScanner(device: HIDDeviceInfo): Promise<any>,
  createChatRoom(config: RoomConfig): Promise<{ ip: string, port: number }>,
  proompt({ apiKey, shopInfo }: { apiKey: string, shopInfo: { prompt: string } }): Promise<string>,
  startAdvertising(): Promise<any>
  startDiscovery(): Promise<any>,
  sendMessage(): Promise<any>
  stopAllConnections(): Promise<any>
}
